import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/common/Something";
import { useParams } from "react-router";
import BackToolNav from "../../../components/toolnav/BackToolNav";
import { Button, Tooltip } from "antd";
import { FiEdit } from "react-icons/fi";
import ManageWrapper from "..";
import placeholder from "../../../assets/images/placeholder.png";
import { RiDeleteBin4Line } from "react-icons/ri";
import { fetchVehicleDetails } from "../../../api/janjapan";
import { BsChevronDown } from "react-icons/bs";
import {
  HiOutlineClipboardDocument,
  HiOutlineClipboardDocumentCheck,
  HiOutlineClipboardDocumentList,
} from "react-icons/hi2";
import { statusColors } from "../../../utils/statusColors";
import extractJanUrl from "../../../utils/extractJanUrl";
import SyncWidget from "./components/SyncWidget";

export default function OneCar() {
  const { id } = useParams();

  const { data: car, isError } = useQuery({
    queryKey: ["car", id],
    queryFn: () => fetchVehicleDetails({ country_id: 10, car_id: id }),
  });

  return (
    <ManageWrapper
      title={"Vehicle"}
      subtitle={"Vehicle details"}
      actions={
        <div className="flex items-center">
          <Button>
            <FiEdit />
          </Button>

          <Button className="border bg-red-100 ml-2">
            <RiDeleteBin4Line />
          </Button>
        </div>
      }
      toolnav={<BackToolNav />}
    >
      <div className="p-2">
        {isError ? (
          <div className="my-12">
            <Something />
          </div>
        ) : (
          <>
            <div className="grid grid-cols-12 gap-2">
              <div className="col-span-12 sm:col-span-9 border">
                <div className="flex justify-between border-b">
                  <div className="p-4">
                    <div className="flex text-lg">
                      <div className="font-bold uppercase">
                        {car?.data?.makerName} {car?.data?.modelName}
                      </div>
                      <div
                        className="flex items-center px-2"
                        style={{ color: `${statusColors["Available"]}` }}
                      >
                        [ Available ]
                      </div>
                    </div>
                    <div className="">CHASSIS: {car?.data?.chassisNo}</div>
                    <div className="">
                      {car?.data?.makerName} {car?.data?.modelName}
                    </div>
                  </div>

                  <div className="p-4 flex flex-col items-end">
                    <div className="flex">
                      <Tooltip title="Spec Sheet">
                        <div className="bg-blue-600 p-2 rounded-md">
                          <HiOutlineClipboardDocumentList
                            color="#FFF"
                            size={23}
                          />
                        </div>
                      </Tooltip>
                      <Tooltip title="Inspection Sheet">
                        <div className="bg-green-600 p-2 rounded-md ml-2">
                          <HiOutlineClipboardDocumentCheck
                            color="#FFF"
                            size={23}
                          />
                        </div>
                      </Tooltip>
                      <Tooltip title="Contract">
                        <div className="bg-green-600 p-2 rounded-md ml-2">
                          <HiOutlineClipboardDocument color="#FFF" size={23} />
                        </div>
                      </Tooltip>
                    </div>
                    <button className="flex items-center mt-1">
                      <div className="flex mr-1 items-center">
                        <span className="mr-1">{car?.data?.cityName}</span>
                        <span>Model Code: {car?.data?.modelCode}</span>
                      </div>

                      <BsChevronDown />
                    </button>
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-2  p-2">
                  <div className="col-span-12 sm:col-span-6 bg-gray-100">
                    <button className="">
                      <img
                        src={extractJanUrl(car?.data?.carImages[0]?.imagePath)}
                        alt=""
                        width={"1080"}
                      />
                    </button>
                  </div>
                  <div className="col-span-12 sm:col-span-6">
                    <div className="flex justify-between">
                      {/* INTERIOR */}
                      <div className="">
                        <div className="text-center bg-gray-200 border-b-2 border-gray-300">
                          EXTERIOR
                        </div>
                        <div className="flex">
                          <div className="border bg-gray-100">
                            <button className="">
                              <img
                                src={
                                  car?.data?.carImages[0]?.imagePath ||
                                  placeholder
                                }
                                alt=""
                                width={150}
                              />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img
                                src={
                                  car?.data?.carImages[1]?.imagePath ||
                                  placeholder
                                }
                                alt=""
                                width={150}
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex mt-1">
                          <div className="border bg-gray-100">
                            <button className="">
                              <img
                                src={
                                  car?.data?.carImages[2]?.imagePath ||
                                  placeholder
                                }
                                alt=""
                                width={150}
                              />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img
                                src={
                                  car?.data?.carImages[3]?.imagePath ||
                                  placeholder
                                }
                                alt=""
                                width={150}
                              />
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* EXTERIOR */}
                      <div className="ml-1">
                        <div className="text-center bg-gray-200 border-b-2 border-gray-300">
                          INTERIOR
                        </div>
                        <div className="flex mb-1">
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img
                                src={
                                  car?.data?.carImages[4]?.imagePath ||
                                  placeholder
                                }
                                alt=""
                                width={150}
                              />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img
                                src={
                                  car?.data?.carImages[5]?.imagePath ||
                                  placeholder
                                }
                                alt=""
                                width={150}
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex">
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between mt-2">
                      {/* MECHANICAL */}
                      <div className="">
                        <div className="text-center bg-gray-200 border-b-2 border-gray-300">
                          MECHANICAL
                        </div>
                        <div className="flex">
                          <div className="border bg-gray-100">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                        </div>
                        <div className="flex mt-1">
                          <div className="border bg-gray-100">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* OTHERS */}
                      <div className="ml-1">
                        <div className="text-center bg-gray-200 border-b-2 border-gray-300">
                          OTHERS
                        </div>
                        <div className="flex mb-1">
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img
                                src={car?.data?.carImages[6]?.imagePath}
                                width={150}
                                alt=""
                              />
                            </button>
                          </div>
                          <div className="border bg-gray-100 ml-1">
                            <button className="">
                              <img src={placeholder} width={150} alt="" />
                            </button>
                          </div>
                        </div>
                        <div className="flex">
                          <button
                            className="border bg-gray-100 flex justify-center items-center h-full w-full"
                            style={{ height: 80 }}
                          >
                            Add More Images
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-12 sm:col-span-3 border">
                <SyncWidget car={car?.data} />
              </div>
            </div>
          </>
        )}
      </div>
    </ManageWrapper>
  );
}
